import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { Assignment, AssignmentLogEvent, FormattedAssignmentLogEvent, User } from './../model/model';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from './localstorage-service.service';
// Avoid name not found warnings
@Injectable()
export class AssignmentService {
    public user: User;
    public queryEndPointGroup = 'query-api/Group';
    public queryEndPointAssignment = 'query-api/Assignment';

    constructor(private http: HttpClient, private storageService : LocalstorageService, private userService: UserService) { }

    getAssignmentsByGroup = (groupId) => {
        return this.http.get<Assignment[]>(`${this.queryEndPointGroup}/${groupId}/Assignments`);
    }

    getLog = (id: string) => this.http.get<AssignmentLogEvent[]>(`${this.queryEndPointAssignment}/${id}/logevents`);
    getFormattedLog = (id: string) =>
        this.http.get<FormattedAssignmentLogEvent[]>(`${this.queryEndPointAssignment}/${id}/logevents/formatted`)
}
